import { format } from "date-fns";
import { DayPlan } from "./DayPlan";
import { ChecklistItem } from "./ChecklistItem";
import { Goal } from "./Goal";
import { Task } from "./Task";
import { LifePart } from "./LifePart";

export function getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


export function emptyLifepart(): LifePart {
    return {
        uuid: crypto.randomUUID(),
        name: "",
        color: getRandomColor(),
        description: "",
        startpoint: 1,
        primary: false,
    };
}

export function emptyTask(lifepart: LifePart | string, description?: string, order = 0): Task {
    return {
        uuid: crypto.randomUUID(),
        description: description || "",
        context: "",
        order: order,
        isDone: false,
        lifepart: typeof lifepart === 'string' ? lifepart : lifepart.uuid,
        labels: [],
        stepOrder: 0,
    };
}

export function emptyChecklistItem(taskUUid: string): ChecklistItem {
    return {
        uuid: crypto.randomUUID(),
        task: taskUUid,
        title: "",
        isDone: false,
        needTime: "00:00",
        needMoney: null
    };
}

export function emptyGoal(lifepart: LifePart, order = 0): Goal {
    return {
        uuid: crypto.randomUUID(),
        description: "",
        isDone: false,
        lifepart: lifepart.uuid,
        order: order,
    };
}

export function emptyPlan(goal: Task, date: Date, ordering: number): DayPlan {
    return {
        uuid: crypto.randomUUID(),
        isDone: false,
        task: goal.uuid,
        date: format(date, "yyyy-MM-dd"),
        ordering,
        needTime: "00:00",
        needMoney: null
    };
}